var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'position-absolute' : _vm.numberUnreadMessages > 0, 'show-icon-nbr': _vm.shownInMessageBox},attrs:{"id":"bulle-unread-msgs"}},[_c('span',{staticClass:"nbr-unread-msgs"},[_vm._v(" "+_vm._s(_vm.numberUnreadMessages)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }